// Test IDs for Document Center landing page
export const DOC_CENTER = {
  nav: {
    container: "nav-root",
    logo: "nav-logo",
    linkProduct: "nav-link-product",
    linkWorkspace: "nav-link-workspace",
    linkFAQ: "nav-link-faq",
    ctaOpen: "nav-cta-open",
    ctaCreate: "nav-cta-create",
  },
  hero: {
    section: "section-hero",
    primaryCta: "hero-cta-primary",
    secondaryCta: "hero-cta-secondary",
    workspaceMock: "hero-workspace-mock",
    documentCard: (slug) => `hero-doc-card-${slug}`,
  },
  problem: {
    section: "section-problem",
  },
  why: {
    section: "section-why",
    card: (slug) => `why-card-${slug}`,
  },
  search: {
    section: "section-search",
    input: "search-input",
    chip: (slug) => `search-chip-${slug}`,
    result: (slug) => `search-result-${slug}`,
  },
  connected: {
    section: "section-connected",
    node: (slug) => `connected-node-${slug}`,
  },
  workspace: {
    section: "section-workspace",
    layer: (slug) => `workspace-layer-${slug}`,
  },
  outcomes: {
    section: "section-outcomes",
    card: (slug) => `outcome-card-${slug}`,
  },
  faq: {
    section: "section-faq",
    trigger: (idx) => `faq-trigger-${idx}`,
    content: (idx) => `faq-content-${idx}`,
  },
  finalCta: {
    section: "section-final-cta",
    primary: "final-cta-primary",
    secondary: "final-cta-secondary",
    email: "final-cta-email",
    submit: "final-cta-submit",
  },
  footer: {
    container: "footer-root",
  },
};
